export const sm = '4px';
export const md = '8px';
export const lg = '16px';
